import React, { useState } from 'react';
import { ChartBarIcon, ArrowTrendingUpIcon } from '@heroicons/react/24/outline';
import FeedbackImpactModal from './FeedbackImpactModal';

const FeedbackImpactTrigger = ({ 
  variant = 'button', // 'button', 'card', 'floating'
  className = '',
  showLabel = true 
}) => {
  const [showModal, setShowModal] = useState(false);

  const handleClick = () => {
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
  };

  // Button variant
  if (variant === 'button') {
    return (
      <>
        <button
          onClick={handleClick}
          className={`flex items-center space-x-2 px-4 py-2 bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-lg hover:from-blue-600 hover:to-purple-700 transition-all duration-200 transform hover:scale-105 ${className}`}
        >
          <ArrowTrendingUpIcon className="w-4 h-4" />
          {showLabel && <span className="text-sm font-medium">영향력 보기</span>}
        </button>
        <FeedbackImpactModal isOpen={showModal} onClose={handleClose} />
      </>
    );
  }

  // Card variant
  if (variant === 'card') {
    return (
      <>
        <div 
          onClick={handleClick}
          className={`bg-gradient-to-r from-indigo-500 to-purple-600 text-white p-6 rounded-xl cursor-pointer hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-xl ${className}`}
        >
          <div className="flex items-center space-x-4">
            <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center backdrop-blur-sm">
              <ChartBarIcon className="w-6 h-6" />
            </div>
            <div className="flex-1">
              <h3 className="font-bold text-lg mb-1">피드백 영향력</h3>
              <p className="text-indigo-100 text-sm">여러분의 의견이 만드는 실제 변화</p>
            </div>
            <div className="text-2xl">📊</div>
          </div>
        </div>
        <FeedbackImpactModal isOpen={showModal} onClose={handleClose} />
      </>
    );
  }

  // Floating variant
  if (variant === 'floating') {
    return (
      <>
        <button
          onClick={handleClick}
          className={`fixed bottom-20 left-6 z-40 bg-gradient-to-r from-blue-500 to-purple-600 text-white p-4 rounded-full shadow-2xl hover:scale-110 transition-all duration-300 animate-bounce ${className}`}
          title="피드백 영향력 보기"
        >
          <ArrowTrendingUpIcon className="w-6 h-6" />
        </button>
        <FeedbackImpactModal isOpen={showModal} onClose={handleClose} />
      </>
    );
  }

  return null;
};

export default FeedbackImpactTrigger;